import { SET_FILTER_SERIES, SET_FILTER_SEURA, SET_FILTER_LAHTO, SET_FILTER_SIJA,
   SET_FILTER_MAALI, SET_FILTER_ERO, SET_FILTER_HAKU, SET_FILTER_KERRAT, FETCH_LAST_VER_REFRESH} from '../actions/types'

export const filterReducerSeries = (state = 0, action) => {
  switch (action.type) {
    case SET_FILTER_SERIES:
      return action.filterseries
    default:
      return state
  }
}

export const filterReducerSeura = (state = '', action) => {
  switch (action.type) {
    case SET_FILTER_SEURA:
      return action.filterseura
    default:
      return state
  }
}

export const filterReducerLahto = (state = '', action) => {
  switch (action.type) {
    case SET_FILTER_LAHTO:     
      return action.filterlahto
    default:
      return state
  }
}

export const filterReducerSija = (state = 0, action) => {
  switch (action.type) {
    case SET_FILTER_SIJA:
      return action.filtersija
    default:
      return state
  }
}

export const filterReducerMaali = (state = '', action) => {
  switch (action.type) {
    case SET_FILTER_MAALI:
      return action.filtermaali
    case FETCH_LAST_VER_REFRESH:
      return action.filtermaali
    default:
      return state
  }
}

export const filterReducerEro = (state = '', action) => {
  switch (action.type) {
    case SET_FILTER_ERO:
      return action.filterero
    default:
      return state
  }
}

export const filterReducerHaku = (state = '', action) => {
  switch (action.type) {
    case SET_FILTER_HAKU:
      return action.filterhaku
    default:
      return state
  }
}

export const filterReducerKerrat = (state = '', action) => {
  switch (action.type) {
    case SET_FILTER_KERRAT:
      return action.filterkerrat
    default:
      return state
  }
}